/**
 * Wishlist Manager - Moon Moon Agency
 * Wishlist reservee aux clients connectes : intercepte le clic sur le bouton
 * coeur pour un visiteur non connecte (data-wishlist-guest) et le redirige
 * vers la connexion, avant que le web component ooo-wl-wishlist-button ne le traite.
 */

/*********************************************************************************************
 * 🔧 WISHLIST MANAGER
 */
const WishlistManager = {
	config: {
		selectors: {
			guestTrigger: '[data-wishlist-guest]',
		},
	},

	/**
	 * Initialize the module
	 */
	init() {
		this._bindEvents();
		window.log('info', '🔧 [WISHLIST]', 'Initialized');
	},

	_bindEvents() {
		// Capture = true pour intercepter avant le web component ooo-wl-wishlist-button
		document.addEventListener('click', (e) => {
			const trigger = e.target.closest(this.config.selectors.guestTrigger);
			if (!trigger) return;

			e.preventDefault();
			e.stopImmediatePropagation();
			this._redirectToLogin();
		}, true);
	},

	_redirectToLogin() {
		window.log('info', '🔧 [WISHLIST]', 'Guest redirected to login');
		window.location.href = window.routes?.account_login_url || '/account/login';
	},
};

// Auto-init avec vérification readyState
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => WishlistManager.init());
} else {
	WishlistManager.init();
}
